import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import InputFFXIV from '../../../InputFFXIV';

const TimerDurationSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSetting, isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    const value = settings.timerSeconds === null ? '' : (settings.timerSeconds ?? 0);

    const handleTimerChange = (newSeconds: number) => {
        if (isGameMaster) {
            updateSetting('timerSeconds', newSeconds);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className={`flex gap-3 items-center ${settings.timerSeconds === null ? 'opacity-50' : ''}`}>
            <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                {t('game.config.advancedSettings.timer')}
            </div>
            <InputFFXIV
                value={value}
                onChange={(newValue) => handleTimerChange(newValue)}
                min={10}
                max={300}
                className="!w-[50px]"
                disabled={settings.timerSeconds === null}
            />
        </div>
    );
};

export default TimerDurationSelector;